module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "references-1"
    }
  }, [_c('h1', [_vm._v("References")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Fay MJ et al (2015):")]), _vm._v(" Xenobiotic metabolism in mice lacking the UDP-glucuronosyltransferase 2 family. Drug Metab Dispos; 43: 1838 – 46. "), _c('a', {
    attrs: {
      "href": "http://dmd.aspetjournals.org/content/early/2015/09/09/dmd.115.065482.long",
      "target": "_blank"
    }
  }, [_vm._v("Free article")]), _c('span', {
    staticClass: "underline"
  }, [_vm._v(".")])]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Kopot A (2014):")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://www.aklectures.com/subject/biology",
      "target": "_blank"
    }
  }, [_vm._v("AK lectures on biology")]), _vm._v(".")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4bea5306","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch010.vue
// module id = 90
// module chunks = 0